import React from 'react';
import { Link } from 'react-router-dom';
import heroImg from '../assets/Landing-page-globesmall.png';
import platformImg from '../assets/NaaSCloudsmall.png';
import mduImg from '../assets/MDUsmall.png';
import hospImg from '../assets/Hospitalitysmall.png';
import eduImg from '../assets/EducationSchoolsmall.png';
import warehouseImg from '../assets/Warehousesmall.png';
import eap101Img from '../assets/eap101.png';
import eap102Img from '../assets/eap102.png';
import eap104Img from '../assets/eap104.png';
import oap101Img from '../assets/oap101.png';
import wf196Img from '../assets/wf196.png';
import wf186wImg from '../assets/wf186w.png';
import wf660agImg from '../assets/wf660ag.png';
import ecs1100Img from '../assets/ecs1100-10hp.png';
import ecs4150_28Img from '../assets/ecs4150-28p.png';
import ecs4150_54Img from '../assets/ecs4150-54p.png';

const Home = () => {
  return (
    <div style={{ backgroundColor: '#000503', color: '#fff', minHeight: '100vh' }}>
      {/* Hero Section with background image */}
      <section style={{
        backgroundImage: `linear-gradient(135deg, rgba(0,5,3,0.9) 0%, rgba(8,22,40,0.85) 50%, rgba(8,145,178,0.15) 100%), url(${heroImg})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        padding: '100px 40px 100px',
        textAlign: 'center'
      }}>
        <h1 style={{ fontSize: '3rem', fontWeight: '700', marginBottom: '20px', lineHeight: '1.2' }}>
          Network as a Service<br />for Enterprises of Any Size
        </h1>
        <p style={{ fontSize: '1.25rem', color: '#c4cdd8', maxWidth: '700px', margin: '0 auto 40px', lineHeight: '1.8' }}>
          Cloud-managed WiFi and wired connectivity powered by AI. Deploy reliable, secure networks
          across all your locations with zero hardware lock-in.
        </p>
        <div style={{ display: 'flex', gap: '16px', justifyContent: 'center', flexWrap: 'wrap' }}>
          <Link to="/contact" className="btn-primary">Request a Demo</Link>
          <Link to="/naascloud" className="btn-outline">Explore Platform</Link>
        </div>
      </section>

      {/* Metrics Banner */}
      <section style={{
        padding: '40px 40px',
        background: 'linear-gradient(180deg, #0a1628 0%, #0c1a30 100%)',
        borderBottom: '1px solid #1a2744'
      }}>
        <div style={{
          maxWidth: '1000px', margin: '0 auto',
          display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))', gap: '16px',
          textAlign: 'center'
        }}>
          {[
            { value: '99.9%', label: 'Platform Uptime' },
            { value: '5+', label: 'Global Trials Active' },
            { value: '4', label: 'Industry Verticals' },
            { value: '60%', label: 'OpEx Reduction' }
          ].map((stat, i) => (
            <div key={i}>
              <div className="gradient-text" style={{ fontSize: '2.2rem', fontWeight: '700', marginBottom: '4px' }}>{stat.value}</div>
              <div style={{ color: '#a0aec0', fontSize: '0.9rem' }}>{stat.label}</div>
            </div>
          ))}
        </div>
      </section>

      {/* Platform Screenshot */}
      <section style={{ padding: '60px 40px' }}>
        <div style={{ maxWidth: '1100px', margin: '0 auto', display: 'flex', alignItems: 'center', gap: '30px', flexWrap: 'wrap' }}>
          <div style={{ flex: '1 1 280px' }}>
            <h2 style={{ fontSize: '2rem', marginBottom: '16px' }}>See Your Entire Network at a Glance</h2>
            <p style={{ color: '#a0aec0', lineHeight: '1.8', marginBottom: '20px' }}>
              The Sarvanta NaaS Cloud gives you a single dashboard to monitor, manage, and optimize
              every access point, switch, and client across all your locations in real time.
            </p>
            <ul style={{ color: '#a0aec0', lineHeight: '2.2', paddingLeft: '20px', marginBottom: '24px' }}>
              <li>Real-time device health and client metrics</li>
              <li>AI-driven radio optimization recommendations</li>
              <li>Zero-touch provisioning for new sites</li>
              <li>Automated alerting and incident response</li>
            </ul>
            <Link to="/naascloud" className="btn-primary" style={{ fontSize: '0.95rem', padding: '12px 28px' }}>Explore the Platform</Link>
          </div>
          <div style={{ flex: '1 1 280px' }}>
            <img src={platformImg} alt="Sarvanta NaaS Cloud Platform" style={{
              width: '100%', borderRadius: '12px', border: '1px solid #1a2744',
              boxShadow: '0 12px 40px rgba(8,145,178,0.15)'
            }} />
          </div>
        </div>
      </section>

      {/* Key Value Props */}
      <section style={{ padding: '60px 40px', maxWidth: '1200px', margin: '0 auto' }}>
        <h2 style={{ textAlign: 'center', fontSize: '2rem', marginBottom: '50px' }}>Why Sarvanta</h2>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', gap: '30px' }}>
          {[
            {
              title: 'AI-Powered Radio Management',
              desc: 'Our ML-based radio resource management continuously optimizes your network for peak performance, reducing interference and maximizing throughput automatically.'
            },
            {
              title: 'Cloud-Native NaaS Platform',
              desc: 'Manage all your locations from a single pane of glass. Zero-touch provisioning, real-time monitoring, and automated operations reduce OpEx by up to 60%.'
            },
            {
              title: 'Open Hardware, No Lock-In',
              desc: 'Deploy cost-effective white-box access points and PoE switches from multiple vendors. Avoid proprietary lock-in while maintaining enterprise-grade quality.'
            },
            {
              title: 'Real-Time Quality of Experience',
              desc: 'Measure and optimize the actual end-user experience with real-time QoE metrics. Identify and resolve issues before users even notice them.'
            },
            {
              title: 'Enterprise-Grade Security',
              desc: 'Network Access Control with PacketFence and FreeRADIUS, 802.1X authentication, device isolation, and content filtering built into the platform.'
            },
            {
              title: 'Rapid Deployment',
              desc: 'Go from unboxing to fully operational in minutes. Zero-touch provisioning means your access points configure themselves when connected to the internet.'
            }
          ].map((item, i) => (
            <div key={i} className="card-hover" style={{
              padding: '30px',
              background: 'linear-gradient(135deg, rgba(10,22,40,0.8) 0%, rgba(12,26,48,0.6) 100%)',
              borderRadius: '12px',
              border: '1px solid #1a2744',
              backdropFilter: 'blur(10px)'
            }}>
              <h3 style={{ fontSize: '1.2rem', marginBottom: '12px', color: '#22d3ee' }}>{item.title}</h3>
              <p style={{ color: '#a0aec0', lineHeight: '1.7', margin: 0 }}>{item.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Open Hardware Showcase */}
      <section style={{
        padding: '60px 40px',
        background: 'linear-gradient(135deg, #000503 0%, rgba(8,145,178,0.05) 100%)',
        borderTop: '1px solid #1a2744'
      }}>
        <div style={{ maxWidth: '1100px', margin: '0 auto' }}>
          <h2 style={{ textAlign: 'center', fontSize: '2rem', marginBottom: '12px' }}>Open Hardware, Your Choice</h2>
          <p style={{ textAlign: 'center', color: '#a0aec0', maxWidth: '600px', margin: '0 auto 40px', lineHeight: '1.7' }}>
            Enterprise-grade access points and switches from multiple vendors. No proprietary lock-in.
          </p>

          {/* Access Points */}
          <h3 style={{ fontSize: '1.3rem', marginBottom: '20px', color: '#22d3ee' }}>Access Points</h3>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))', gap: '20px', marginBottom: '40px' }}>
            {[
              { name: 'Edgecore EAP101', type: 'Ceiling Mount', spec: 'WiFi 6 · 2x2:2 MU-MIMO', img: eap101Img },
              { name: 'Edgecore EAP102', type: 'Ceiling Mount', spec: 'WiFi 6 · 4x4:4 MU-MIMO · 2.9 Gbps', img: eap102Img },
              { name: 'Edgecore EAP104', type: 'Wall Plate', spec: 'WiFi 6 · 2x2:2 MU-MIMO', img: eap104Img },
              { name: 'Edgecore OAP101', type: 'Outdoor', spec: 'WiFi 6E · IP68 · All-Weather', img: oap101Img },
              { name: 'CIG WF-196', type: 'Ceiling Mount', spec: 'WiFi 6E · Tri-band · 4x4 MU-MIMO', img: wf196Img },
              { name: 'CIG WF-186W', type: 'Wall Plate', spec: 'WiFi 6 · 2x2:2 MU-MIMO', img: wf186wImg },
              { name: 'CIG WF-660AG', type: 'Outdoor', spec: 'WiFi 6 · 2x2:2 MU-MIMO', img: wf660agImg }
            ].map((hw, i) => (
              <Link key={i} to="/openhardware" className="card-hover" style={{
                padding: '20px', textAlign: 'center',
                background: 'linear-gradient(135deg, rgba(10,22,40,0.8) 0%, rgba(12,26,48,0.6) 100%)',
                borderRadius: '12px', border: '1px solid #1a2744',
                textDecoration: 'none', color: '#fff', display: 'block'
              }}>
                <div style={{
                  height: '140px', display: 'flex', alignItems: 'center', justifyContent: 'center',
                  marginBottom: '12px'
                }}>
                  <img src={hw.img} alt={hw.name} style={{
                    maxHeight: '120px', maxWidth: '100%', objectFit: 'contain',
                    filter: 'drop-shadow(0 8px 20px rgba(0,0,0,0.4))'
                  }} />
                </div>
                <h3 style={{ fontSize: '1rem', marginBottom: '4px' }}>{hw.name}</h3>
                <p style={{ color: '#22d3ee', fontSize: '0.85rem', marginBottom: '4px', fontWeight: '600' }}>{hw.type}</p>
                <p style={{ color: '#a0aec0', fontSize: '0.8rem', margin: 0 }}>{hw.spec}</p>
              </Link>
            ))}
          </div>

          {/* OpenLAN PoE Switches */}
          <h3 style={{ fontSize: '1.3rem', marginBottom: '20px', color: '#22d3ee' }}>OpenLAN PoE Switches</h3>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', gap: '20px' }}>
            {[
              { name: 'Edgecore ECS1100-10HP', type: '10-Port PoE Switch', spec: '8 × 1G PoE (802.3bt) · 250W Budget', img: ecs1100Img },
              { name: 'Edgecore ECS4150-28P', type: '28-Port PoE Switch', spec: '24 × 1G PoE · 4 × 10G SFP+ Uplinks', img: ecs4150_28Img },
              { name: 'Edgecore ECS4150-54P', type: '48-Port PoE Switch', spec: '48 × 1G PoE · 6 × 25G SFP28 · 740W', img: ecs4150_54Img }
            ].map((hw, i) => (
              <Link key={i} to="/openhardware" className="card-hover" style={{
                padding: '24px', textAlign: 'center',
                background: 'linear-gradient(135deg, rgba(10,22,40,0.8) 0%, rgba(12,26,48,0.6) 100%)',
                borderRadius: '12px', border: '1px solid #1a2744',
                textDecoration: 'none', color: '#fff', display: 'block'
              }}>
                <div style={{
                  height: '160px', display: 'flex', alignItems: 'center', justifyContent: 'center',
                  marginBottom: '14px'
                }}>
                  <img src={hw.img} alt={hw.name} style={{
                    maxHeight: '140px', maxWidth: '100%', objectFit: 'contain',
                    filter: 'drop-shadow(0 8px 20px rgba(0,0,0,0.4))'
                  }} />
                </div>
                <h3 style={{ fontSize: '1.05rem', marginBottom: '4px' }}>{hw.name}</h3>
                <p style={{ color: '#22d3ee', fontSize: '0.9rem', marginBottom: '4px', fontWeight: '600' }}>{hw.type}</p>
                <p style={{ color: '#a0aec0', fontSize: '0.8rem', margin: 0 }}>{hw.spec}</p>
              </Link>
            ))}
          </div>

          <div style={{ textAlign: 'center', marginTop: '30px' }}>
            <Link to="/openhardware" className="btn-outline" style={{ padding: '12px 28px' }}>View All Hardware</Link>
          </div>
        </div>
      </section>

      {/* Industries with images */}
      <section style={{
        padding: '60px 40px',
        background: 'linear-gradient(180deg, #0a1628 0%, #0d1f3c 50%, #0a1628 100%)'
      }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
          <h2 style={{ textAlign: 'center', fontSize: '2rem', marginBottom: '16px' }}>
            Purpose-Built for Your Industry
          </h2>
          <p style={{ textAlign: 'center', color: '#a0aec0', marginBottom: '50px', maxWidth: '600px', margin: '0 auto 50px' }}>
            Tailored connectivity solutions addressing the unique challenges of each vertical.
          </p>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', gap: '24px' }}>
            {[
              { name: 'Multi-Dwelling Units', path: '/mdu', desc: 'Resident WiFi that attracts tenants and boosts revenue.', img: mduImg },
              { name: 'Hospitality', path: '/hospitality', desc: 'Guest WiFi with Personal Area Networks and real-time management.', img: hospImg },
              { name: 'Education', path: '/education', desc: 'Secure campus networks with content filtering and device controls.', img: eduImg },
              { name: 'Warehouses', path: '/warehouses', desc: 'High-coverage industrial WiFi for operations and IoT.', img: warehouseImg }
            ].map((item, i) => (
              <Link key={i} to={item.path} className="card-hover" style={{
                backgroundColor: '#000503', borderRadius: '12px',
                border: '1px solid #1a2744', textDecoration: 'none', color: '#fff',
                overflow: 'hidden', display: 'block'
              }}>
                <div style={{
                  height: '160px', overflow: 'hidden',
                  backgroundImage: `url(${item.img})`,
                  backgroundSize: 'cover', backgroundPosition: 'center'
                }} />
                <div style={{ padding: '20px' }}>
                  <h3 style={{ fontSize: '1.1rem', marginBottom: '8px' }}>{item.name}</h3>
                  <p style={{ color: '#a0aec0', fontSize: '0.9rem', margin: 0, lineHeight: '1.6' }}>{item.desc}</p>
                  <span style={{ color: '#22d3ee', marginTop: '12px', display: 'inline-block', fontWeight: '600', fontSize: '0.85rem' }}>
                    Learn more &rarr;
                  </span>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Team Credibility */}
      <section style={{ padding: '60px 40px', textAlign: 'center' }}>
        <h2 style={{ fontSize: '2rem', marginBottom: '16px' }}>Built by Industry Veterans</h2>
        <p style={{ color: '#a0aec0', maxWidth: '700px', margin: '0 auto 30px', lineHeight: '1.8' }}>
          Our leadership team brings decades of experience from Cisco, Comcast, Ruckus Wireless,
          Fujitsu, and Plume WiFi. We have built massively scalable cloud-native platforms
          and enterprise networking products used by millions.
        </p>
        <Link to="/about" className="btn-outline" style={{ padding: '12px 28px' }}>Meet the Team</Link>
      </section>

      {/* Technology Partners */}
      <section style={{ padding: '50px 40px', borderTop: '1px solid #1a2744' }}>
        <p style={{ textAlign: 'center', color: '#64748b', fontSize: '0.85rem', textTransform: 'uppercase', letterSpacing: '0.1em', marginBottom: '30px' }}>
          Built on Trusted Technology
        </p>
        <div style={{
          display: 'flex', justifyContent: 'center', alignItems: 'center',
          gap: '40px', flexWrap: 'wrap', maxWidth: '900px', margin: '0 auto'
        }}>
          {['PacketFence', 'FreeRADIUS', 'OpenWrt', 'EdgeCore', 'CIG'].map((name, i) => (
            <span key={i} style={{
              color: '#4a5568', fontSize: '1.1rem', fontWeight: '600',
              letterSpacing: '0.02em', padding: '8px 16px',
              border: '1px solid #1a2744', borderRadius: '8px',
              transition: 'border-color 0.2s'
            }}>{name}</span>
          ))}
        </div>
      </section>

      {/* CTA */}
      <section style={{
        padding: '60px 40px',
        background: 'linear-gradient(135deg, #0a1628 0%, rgba(8,145,178,0.1) 100%)',
        textAlign: 'center'
      }}>
        <h2 style={{ fontSize: '2rem', marginBottom: '16px' }}>Ready to Transform Your Network?</h2>
        <p style={{ color: '#a0aec0', marginBottom: '30px' }}>
          Get in touch to see how Sarvanta can simplify your network operations.
        </p>
        <Link to="/contact" className="btn-primary">Contact Us</Link>
      </section>
    </div>
  );
};

export default Home;
